import React from "react";
import Container from "@mui/material/Container";
import Buttons from "../../Button/Button";
import styles from "./BecomesTeacherSec.module.css";

const BecomesTeacherSec = () => {
  return (
    <div className="Section" id="becomes-teacher" style={{marginBottom:"32px"}}>
      <Container maxWidth="lg" sx={{maxWidth:"1304px !important;" }}>
        <div className={styles.BecomeaTeacherContent}>
          <div className={styles.BecomeaTeacherTitle}>
          Share your knowledge & wisdom <br></br> with the Ummah
          </div>
          <div className={styles.BecomeaTeacherDescription}>
          Your knowledge is an a’manah.<br></br>
          Teach your own course at your own terms with global Muslim community.
          </div>

          <div className={styles.BecomeaTeacherButton}>
          <Buttons
            label="Become a teacher"
            buttonColor="#FFFFFF"
            color="#004FE0"
            height="60px"
            fontSize="20px"
            fontWeight={500}
            link="/teach"
            borderRadius="12px"
          />
           </div>
        </div>
      </Container>
    </div>
  );
};

export default BecomesTeacherSec;
